import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
// import Dashboard_Nav from "./components/Dashboard_Nav";
import CardGeneration from "./pages/Post_Signup/CardGeneration";
import Home from "./pages/Pre_Signup/Home";
import Error404 from "./pages/Error404";
import AddressBook from "./pages/Post_Signup/AddressBook";
import AddRecipient from "./pages/Post_Signup/AddRecipient";
import Profile from "./pages/Post_Signup/Profile";
import Nav from "./components/Nav";
import Login from "./pages/Pre_Signup/Login";
import Signup from "./pages/Pre_Signup/Signup";
import CalenderTab from "./pages/Post_Signup/Calender";
// import Favorites from "./pages/Post_Signup/Favorites";
import Draft from "./pages/Post_Signup/Draft";
import Help from "./pages/Post_Signup/Help";
import Settings from "./pages/Post_Signup/Settings";
import PremiumPlan from "./pages/Post_Signup/PremiumPlan";
import RecipientDetails from "./pages/Post_Signup/RecipientDetails";
import EditRecipient from "./pages/Post_Signup/EditRecipient";
import ForgotPassword from "./pages/Pre_Signup/ForgotPassword";
import ResetPassword from "./pages/Pre_Signup/ResetPassword";
import NoSignupAddRecipient from "./pages/No_Signup/AddRecipient";
import PickCard from "./pages/Post_Signup/PickCard";
import BrowseCards from "./pages/Pre_Signup/BrowseCards";
import EventsDetails from "./pages/Post_Signup/EventDetails";
import SendToPrint from "./pages/Post_Signup/SendToPrint";
import EditProfile from "./pages/Post_Signup/EditProfile";
import ProfileResetPassword from "./pages/Post_Signup/ProfileResetPassword";
import AboutUs from "./pages/Pre_Signup/AboutUs";
import Blogs from "./pages/Pre_Signup/Blogs";
import Pricing from "./pages/Pre_Signup/Pricing";
import FullBlog from "./pages/Pre_Signup/FullBlog";
import { useFacebookPixel } from "./hooks/metaPixelHook";
import Cart from "./components/Cart";

function App() {
  useFacebookPixel();
  return (
    <div>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover={false}
        theme="colored"
      />
      <BrowserRouter>
        <Nav />
        <div>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/blogs/:id" element={<FullBlog />} />
            <Route path="/aboutus" element={<AboutUs />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/browse_cards" element={<BrowseCards />} />
            <Route path="/forgot_password" element={<ForgotPassword />} />
            <Route path="/reset_password" element={<ResetPassword />} />
            <Route path="/no_signup/add" element={<NoSignupAddRecipient />} />
            <Route
              path="/dashboard/card_generation"
              element={<CardGeneration />}
            />{" "}
            <Route path="/browse_cards/:cardType" element={<BrowseCards />} />{" "}
            {/* <Route
              path="/dashboard/card_generation/wedding-card"
              element={<CardGeneration />}
            />{" "}*/}
            <Route path="/pricing" element={<Pricing />} />
            <Route
              path="/dashboard/card_generation/pick"
              element={<PickCard />}
            />
            <Route path="/dashboard/calender" element={<CalenderTab />} />
            {/* <Route path="/dashboard/favorite" element={<Favorites />} /> */}
            <Route path="/dashboard/draft" element={<Draft />} />
            <Route path="/dashboard/print" element={<SendToPrint />} />
            <Route path="/dashboard/premium_plan" element={<PremiumPlan />} />
            <Route path="/dashboard/help" element={<Help />} />
            <Route path="/dashboard/settings" element={<Settings />} />
            <Route path="/dashboard/profile" element={<Profile />} />
            <Route path="/dashboard/address_book" element={<AddressBook />} />
            <Route
              path="/dashboard/reset_password"
              element={<ProfileResetPassword />}
            />
            <Route
              path="/dashboard/event_details"
              element={<EventsDetails />}
            />
            <Route
              path="/dashboard/address_book/add"
              element={<AddRecipient />}
            />
            <Route
              path="/dashboard/address_book/details/:id"
              element={<RecipientDetails />}
            />
            <Route
              path="/dashboard/address_book/edit/:id"
              element={<EditRecipient />}
            />
            <Route path="/dashboard/profile/edit" element={<EditProfile />} />
            <Route path="*" element={<Error404 />} />
            <Route path="/dashboard/cart" element={<Cart />} />

          </Routes>
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;
